import React, { Component } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import '../../includes/custom/css/header.css';
import '../../includes/custom/css/custom-bootstrap.css';
import '../../includes/custom/css/navigation.css';
import SHSAALOGO from '../../includes/img/logo.png';
import LogoutIcon from '../../includes/img/svg/logout.svg';
import { FaBars } from 'react-icons/fa';
import { SHS_ADMIN } from './../../utils/constants';

class MainHeader extends Component {

    toggle = () => {
        if (document.getElementById("appSideBar")) {
            if (document.getElementById("appSideBar").offsetLeft === 0) {
                document.getElementById("appSideBar").style.marginLeft = "-370px";
            }
            else {
                document.getElementById("appSideBar").style.marginLeft = "0";
            }
        }
    }

    render() {
        return (
            <Navbar className='header-nav'>
                <Navbar.Brand>
                    <div className='navFlex'>
                        {this.props.isAuthenticated ?
                            <FaBars onClick={() => this.toggle()} color={"#fff"} className="appMenuBar" />
                            :
                            null
                        }
                        <img src={SHSAALOGO} className="header-logo" alt='shs-logo' />
                        <p className="header-appname">{this.props.header ? this.props.header : SHS_ADMIN}</p>
                    </div>
                </Navbar.Brand>
                <Navbar.Collapse>
                    <Nav className="mr-auto">
                    </Nav>
                    {this.props.isAuthenticated && <Nav className='headerRightNav'>
                        <Nav.Link onClick={() => this.props.logoutUser(this.props.accessToken)} className="logoutLabel"> Logout </Nav.Link><img className="logoutButton" src={LogoutIcon} alt='logout' />
                    </Nav>}
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default MainHeader;